import { useMemo } from 'react';
import { useSuppliers } from 'api/hooks/useSuppliers';
import useSupplierLabels from './useSupplierLabels';
import { NamedSelectOption } from 'components/DropDown/ValidatingSelect';

const useSupplierSelectOptions = () => {
  const { data: suppliers, isLoading: suppliersLoading } = useSuppliers();

  const supplierLabels = useSupplierLabels({ suppliers: suppliers?.suppliers });

  const supplierOptions = useMemo<NamedSelectOption[]>(
    () =>
      (suppliers?.suppliers || []).map(supplier => ({
        id: supplier.tenantId,
        label: supplierLabels[supplier.name],
        name: supplier.name,
      })),
    [supplierLabels, suppliers?.suppliers],
  );

  return { suppliers: suppliers?.suppliers, suppliersLoading, supplierLabels, supplierOptions };
};

export default useSupplierSelectOptions;
